module.exports = __webpack_public_path__ + "img/BINDI 1 BW.e3faf0b.svg";